import { createBrowserRouter } from 'react-router-dom'
import { ErrorBoundary, StatusError } from '../components'
import { EnrollmentRoute, enrollmentRouteLoader } from './enrollment-route'
import { PaymentRoute, paymentRouteLoader } from './payment-route'
import { PaymentStatusRoute, paymentStatusRouteLoader } from './payment-status-route'
import { dispatchLoaderEvent } from '../utils/loader'
import { getWhiteLabelBasename } from '../utils/white-label'

export const routes = [
  {
    path: '/payment',
    errorElement: <ErrorBoundary />,
    children: [
      {
        loader: paymentRouteLoader,
        element: <PaymentRoute />,
        index: true,
      },
      {
        path: 'status',
        loader: paymentStatusRouteLoader,
        element: <PaymentStatusRoute />,
        index: true,
      }
    ]
  },
  {
    element: <EnrollmentRoute />,
    path: '/enroll',
    loader: enrollmentRouteLoader,
  },
  {
    loader: () => {
      dispatchLoaderEvent({ showLoader: false })
      return null
    },
    element: <StatusError />,
    path: '*',
  },
]

export const router = createBrowserRouter(routes, { basename: getWhiteLabelBasename() })
